// extracted by mini-css-extract-plugin
export var displayNone = "_p1-6";
export var imgContainer = "_p1-2";
export var overflowHidden = "_p1-3";
export var productInfoCardButtonContainer = "_p1-5";
export var productTitleText = "_p1-4";
export var rightArrow = "_p1-1";
export var rightArrowContainer = "_p1-0";